import { render, staticRenderFns } from "./PayFinished.vue?vue&type=template&id=a60ecd46&scoped=true&"
import script from "./PayFinished.vue?vue&type=script&lang=js&"
export * from "./PayFinished.vue?vue&type=script&lang=js&"
import style0 from "./PayFinished.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PayFinished.vue?vue&type=style&index=1&id=a60ecd46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60ecd46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
